export default __webpack_public_path__ + "static/media/img13.aabc136a.jpg";